import styled from 'styled-components';

export const TableRow = styled.tr(({ theme }) => ({
  cursor: 'pointer',
  padding: 24,
  '&:hover': {
    background: theme.colors.neutral['100'],
  },
}));
